import { DomainRuleError } from "../errors.js";
/**
 * ISO 4217 minor units for the currencies the platform can enable.
 * Which ones are enabled is configuration (operations.corridors), not code.
 */
export const MINOR_UNITS = {
    SGD: 2,
    USD: 2,
    EUR: 2,
    GBP: 2,
    AUD: 2,
    HKD: 2,
    CNY: 2,
    JPY: 0,
    MYR: 2,
    THB: 2,
    IDR: 2,
    VND: 0,
    PHP: 2,
    AED: 2,
    KRW: 0,
    INR: 2,
};
export function isCurrency(value) {
    return Object.hasOwn(MINOR_UNITS, value);
}
export function assertCurrency(value) {
    if (!isCurrency(value)) {
        throw new DomainRuleError("CURRENCY_NOT_ENABLED", `Unsupported currency "${value}"`);
    }
    return value;
}
export function minorUnits(currency) {
    return MINOR_UNITS[currency];
}
export function pow10(exponent) {
    if (exponent < 0 || Math.trunc(exponent) !== exponent)
        throw new RangeError(`Invalid exponent ${exponent}`);
    return 10n ** BigInt(exponent);
}
//# sourceMappingURL=currency.js.map